// removed by extract-text-webpack-plugin
module.exports = {"nav":"nav_nav_BU6Nb","active":"nav_active_3UCDS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/common/nav/nav.scss
// module id = 1541
// module chunks = 0